/**
 * @deprecated Use DashThumbnail instead
 */
class Thumbnail {
    url?: string = '';
    width?: number;
    height?: number;
    localPath?: string;
    color?: string;

    // imageUrl?: string = '';
    // imageLocalPath?: string;
    dimensionSetId?: string;
}

// class ThumbnailNewApi {
//     imageUrl: string = '';
//     width?: number;
//     height?: number;
//     imageLocalPath?: string;
//     dimensionSetId?: string;
// }

class ThumbnailHolder{
    id: number;
    filePaths: Thumbnail[];
}

export { Thumbnail, ThumbnailHolder };
